import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import { AppConfigContext } from '@providers/AppConfigProvider';

interface MenuCloseIconProps {
  onClick: () => void;
}

export default function MenuCloseIcon({ onClick }: MenuCloseIconProps): React.JSX.Element {
  const { pathRoot } = useContext(AppConfigContext);

  return (
    <Box
      className="group flex flex-col items-center justify-center absolute top-4 right-12 max-md:top-3 max-md:right-5 cursor-pointer"
      onClick={onClick}
    >
      <img
        src={`${pathRoot}/assets/images/common/menu_close_white_bar.svg`}
        alt="menu_close_icon"
        className="w-10 h-10 group-hover:opacity-50"
        width="40"
        height="40"
      />
      <img
        src={`${pathRoot}/assets/images/common/close.svg`}
        alt="menu_close"
        className="w-9 h-[10px]"
        width="36"
        height="10"
      />
    </Box>
  );
}
